import ActiveAscending from './ActiveAscending';
import ActiveDescending from './ActiveDescending';
import InactiveSort from './InactiveSort';
import PairConnectorArrow from './PairConnectorArrow';
import Linked from './Linked';
import RoundCheckmark from './RoundCheckmark';
import Event from './Event';
import DeveloperBoard from './DeveloperBoard';
import Month from './Month';
import Star from './Star';
import Week from './Week';
import CashIcon from './CashIcon';
import TransactionIcon from './TransactionIcon';
import DataUsage from './DataUsage';
import PrinterIcon from './PrinterIcon';
import CreditCardIcon from './CreditCardIcon';
import ShoppingCartIcon from './ShoppingCartIcon';
import FilterIcon from './FilterIcon';
import HighlightOffIcon from './HighlightOffIcon';
import ErrorOutlineIcon from './ErrorOutlineIcon';
import CircleCheckIcon from './CircleCheckIcon';
import PersonIcon from './PersonIcon';
import PlacesIcon from './PlacesIcon';
import AssessmentIcon from './AssessmentIcon';
import LabelIcon from './LabelIcon';
import HelpOutlineIcon from './HelpOutlineIcon';
import AnalyticsIcon from './AnalyticsIcon';
import BarcodeIcon from './BarcodeIcon';
import CashRegisterIcon from './CashRegisterIcon';
import GroupIcon from './GroupIcon';
import LightBulbIcon from './LightBulbIcon';
import MapIcon from './MapIcon';
import WallCalendarIcon from './WallCalendarIcon';
import SmartphoneIcon from './SmartphoneIcon';
import PuckIcon from './PuckIcon';
import TuneIcon from './TuneIcon';
import ExitLeftIcon from './ExitLeftIcon';
import DoneAllIcon from './DoneAllIcon';
import SettingIcon from './SettingsIcon';
import LotIcon from './LotIcon';
import AppDrawerIcon from './AppDrawerIcon';
import AlertIcon from './AlertIcon';
import FlagIcon from './FlagIcon';
import SearchIcon from './SearchIcon';
import PSpot from './PSpot';
import PHWordMark from './PHWordMark';



export {
  ActiveAscending,
  ActiveDescending,
  AlertIcon,
  AnalyticsIcon,
  AppDrawerIcon,
  AssessmentIcon,
  BarcodeIcon,
  CashIcon,
  CashRegisterIcon,
  CircleCheckIcon,
  CreditCardIcon,
  DataUsage,
  DeveloperBoard,
  DoneAllIcon,
  ErrorOutlineIcon,
  Event,
  ExitLeftIcon,
  FilterIcon,
  FlagIcon,
  GroupIcon,
  HelpOutlineIcon,
  HighlightOffIcon,
  InactiveSort,
  LabelIcon,
  LightBulbIcon,
  Linked,
  LotIcon,
  Month,
  MapIcon,
  PairConnectorArrow,
  PersonIcon,
  PlacesIcon,
  PrinterIcon,
  PuckIcon,
  RoundCheckmark,
  SearchIcon,
  SettingIcon,
  ShoppingCartIcon,
  SmartphoneIcon,
  Star,
  TransactionIcon,
  TuneIcon,
  WallCalendarIcon,
  Week,
  PSpot,
  PHWordMark
};



// WEBPACK FOOTER //
// ./src/assets/react-icons/index.js